import { createUseStyles } from 'react-jss'
import { fontWeightBold } from '../../../../styles/typography'
import { black } from '../../../../styles/const/colors'

const useStyles = createUseStyles({
  description: {
    fontSize: 18,
    fontWeight: fontWeightBold,
    color: black,
    marginTop: 10
  },
  picturesLogo: {
    marginLeft: 15
  }
})

export default useStyles
